// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
// COMPONENTS
import BlockUi from 'react-block-ui';
import { Spinner } from 'react-bootstrap';
// ICONS
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
//SERVICES AND HELPERS
import * as dashboardService from '../../../../services/dashboard/dashboardService';
import * as quickBookBillsAndChecksService from '../../../../services/service/quickBookBillsAndChecksService';

const QuickBooksData = (props) => {
  const { auth, jobInfo, projectNumber } = props;
  const [quickBooksData, setQuickBooksData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth && auth.user && Object.keys(auth.user).length > 0 && (auth.user.username === 'admin' || auth.user.username === 'Chip')) {
      fetchQuickBooksData();
    }
  }, [projectNumber]);

  const fetchQuickBooksData = () => {
    setLoading(true);
    quickBookBillsAndChecksService
      .getQuickBooksData(projectNumber || '')
      .then((res) => {
        setQuickBooksData(res);
      })
      .catch((err) => {
        console.log('error getting quickbooks data', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const quickBooksBillAndChecksColumn = [
    {
      name: 'projectNumber',
      label: 'Project Number',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'project-number',
          'data-aes-label': 'Project Number',
        }),
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'amount',
          'data-aes-label': 'Amount',
        }),
      },
    },
    {
      name: 'category',
      label: 'Category',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'category',
          'data-aes-label': 'Category',
        }),
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'description',
          'data-aes-label': 'Description',
        }),
      },
    },
    {
      name: 'transactionDate',
      label: 'Transaction Date',
      options: {
        filter: false,
        sort: true,
        print: false,
        download: true,
        setCellProps: () => ({
          'data-aes-field': 'transaction-date',
          'data-aes-label': 'Transaction Date',
        }),
        customBodyRenderLite: (dataIndex) => (
          <CustomBlock className='content-container--actions flex-start pl-0 mt-0'>
            <p>
              {quickBooksData[dataIndex].transactionDate ? moment(quickBooksData[dataIndex].transactionDate).format('MM/DD/YYYY A') : '-'}
            </p>
          </CustomBlock>
        ),
      },
    },
    {
      name: 'transactionType',
      label: 'Transaction Type',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'transaction-type',
          'data-aes-label': 'Transaction Type',
        }),
      },
    },
  ];

  return (
    <BlockUi tag='div' blocking={loading}>
      <CustomBlock className='aes-dashboard-quickbooks mt-10'>
        <div className='card card-custom aes-dashboard-quickbooks__card'>
          <div className='card-header py-3 border-0'>
            <div className='card-title align-items-start flex-column'>
              <h3 className='card-label font-weight-bolder text-dark mb-0'>Bills And Checks</h3>
            </div>
          </div>

          <div className='card-body aes-dashboard-quickbooks__body pt-0'>
            <CustomBlock
              className={`aes-dashboard-quickbooks__listing${
                quickBooksData.length === 0 ? ' aes-dashboard-quickbooks__listing--empty' : ''
              }`}
            >
              <MUIDataTable
                className='aes-dashboard-quickbooks__surface'
                data={quickBooksData}
                columns={quickBooksBillAndChecksColumn}
                options={{
                  responsive: 'standard',
                  rowsPerPage: 10,
                  rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                  selectableRows: 'none',
                  pagination: quickBooksData.length > 0,
                  setTableProps: () => ({
                    className: 'aes-dashboard-quickbooks__table',
                  }),
                  textLabels: {
                    body: {
                      noMatch: loading ? (
                        <Spinner animation='border' size='lg' variant='info' />
                      ) : (
                        <span className='aes-dashboard-quickbooks__empty'>No bills or checks found.</span>
                      ),
                    },
                  },
                }}
              />
            </CustomBlock>
          </div>
        </div>
      </CustomBlock>
    </BlockUi>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  ...alert.actions,
})(QuickBooksData);
